import React from 'react';
import PropTypes from 'prop-types';
import { MicroFrontEndEmbed } from 'components/core/MicroFrontEndEmbed';
import { H2, Paragraph, Text } from 'components/core/Typography';

import './StorageCalculatorEmbedSGP.scss';
import { compose, withState } from 'recompose';
import { getStorageCalcInfo } from 'store/selectors/app';
import { connect } from 'react-redux';

import ErrorIcon from '/assets/images/error/error.svg';
import StorageCalculatorIcon from 'assets/images/icons/business-storage-guide/storage-calculator.svg';
import { Image } from 'components/core/Image';

const ErrorBanner = ({ message }) => (
	<div className="error-banner">
		<Image
			src={ErrorIcon}
			alt="Error icon"
		/>

		<Text
			size="tall"
			weight="medium"
			color="black"
		>
			{message}
		</Text>
	</div>
);

const HeaderSegment = ({ type }) => {
	const isFacilityType = type === 'facility';
	
	return (
		<div>
			<Paragraph
				size="standard"
				color="black"
				weight="standard"
				className="sf-size-guide-calculator-description"
			>
				{isFacilityType
					? <>Browse a range of commonly stored items like furniture, mattresses, boxes, and appliances. From kitchen essentials to bedroom furniture, living room decor, office supplies, dining room pieces, garage gear, and more—our tool helps you make an informed choice.{' '}</>
					: <>Select from a list of frequently stored objects such as furniture, mattresses, boxes, and appliances. You'll find common daily items from your kitchen, bedroom, living room, office, bathrooms, dining room, garage, and other home spaces.{' '}</>
				}
			</Paragraph>
		</div>
	);
};

export const StorageCalculatorEmbedSGP = ({
	storageCalculatorUrl,
	type,
	hasError,
	setHasError,
}) => {
	return (
		<div className="calculator-container">
			<div className="top-size-text-container">
				<div className='top-size-heading-container'>
					<Image
						src={StorageCalculatorIcon}
						alt="storage-calculator"
						className="storage-calculator-icon"
					/>
					<H2
						size="xlarge"
						color="black"
						weight="bold"
						family="rounded"
						className="desktop-header-text"
					>
						Storage Unit Size Calculator
					</H2>
				</div>

			</div>
				<div className="storage-calculator-header-right">
					<HeaderSegment type={type} />
				</div>

			{hasError && (
				<ErrorBanner message="There was an issue loading the storage calculator. Try reloading the page or come back later." />
			)}
			<MicroFrontEndEmbed
				id="st-storage-calculator"
				scriptURL={`${storageCalculatorUrl}/assets/index.js`}
				stylesheetURL={`${storageCalculatorUrl}/assets/index.css`}
				className="storage-calculator"
				data={{ 'data-site': 'SFDC' }}
				onLoad={() => {
					setHasError(false);
				}}
				onError={() => {
					setHasError(true);
				}}
			/>
		</div>
	);
};

// PropTypes
ErrorBanner.propTypes = {
	message: PropTypes.string.isRequired,
};

HeaderSegment.propTypes = {
	type: PropTypes.string,
};

StorageCalculatorEmbedSGP.propTypes = {
	handleMFELoad: PropTypes.func,
	storageCalculatorUrl: PropTypes.string,
	type: PropTypes.string,
	hasError: PropTypes.bool.isRequired,
	setHasError: PropTypes.func.isRequired,
};

// Enhancement composition
export const enhance = compose(
	connect((state) => ({
		storageCalculatorUrl: getStorageCalcInfo(state),
	})),
	withState('hasError', 'setHasError', false),
);

// Export the enhanced component
export default enhance(StorageCalculatorEmbedSGP);
